export default __webpack_public_path__ + "static/media/eye_off.59fd23e5.svg";